import styled from 'styled-components';

export const Divider = styled.div`
  height: 8px;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: calc(100vh - 136px);
`;

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px 11px 0px 16px;
  overflow-y: auto;
  height: 100vh;
  /* max-height: calc(100vh - 136px); */

  .textDefault {
    color: #000;
    font-family: Roboto;
    font-size: 11px;
    font-style: normal;
    font-weight: 300;
    line-height: 18px; /* 145.455% */
  }

  .mapa {
    width: 553px;
    height: 264px;
  }

  .container-box {
    display: flex;
    width: 100%;
    gap: 12px;
    flex-wrap: wrap;
  }

  .container-error {
    display: flex;
    justify-content: space-between;
    align-items: center;

    color: #5e5e5e;
    font-family: Roboto;
    font-size: 9px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px; /* 177.778% */

    padding: 4px 0px 0px 0px;
    /*Ajustar o espaçamento entre linhas*/
    line-height: 1.2;
  }

  /* Tabela */
  .table-header th {
    border-bottom: 0.3px solid #ababab;
    text-align: left;
    color: #5e5e5e;
    font-family: Roboto;
    font-size: 10px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px; /* 160% */
  }

  tbody td {
    color: #5e5e5e;
    font-family: Roboto;
    font-size: 11px;
    font-style: normal;
    font-weight: 400;
    line-height: 13px; /* 118.182% */
  }

  .title-table-int {
    border: 1px solid red;
  }

  .leaflet-control-minimap {
    margin-bottom: -16px !important;
  }

  .mapBottomRight {
    float: right;
    position: relative;
    bottom: 32px;
    z-index: 1400;
  }

  .retangulo-minimap-report {
    stroke-width: 3;
    fill: rgba(255, 255, 255, 0.3);
    stroke: #ff6f45;
  }
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  padding: 8px 4px 5px 4px;
  background: #fff;
  border-bottom: 0.5px solid #5e5e5e;

  .title {
    color: #3c71dd;
    font-family: Roboto;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 16px; /* 100% */
  }
`;

export const Subtitle = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  padding: 0px 4px 0px 4px;
  background: #fff;
  margin-top: -15px;

  input {
    /* tirar as bordas*/
    border: none;
    outline: none;
    width: 80%;

    &::placeholder {
      color: #5e5e5e;
      font-family: Roboto;
      font-size: 12px;
      font-style: italic;
      font-weight: 400;
      line-height: 16px; /* 133.333% */
    }

    color: #5e5e5e;
    font-family: Roboto;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px; /* 133.333% */
  }
  span {
    color: #5e5e5e;
    text-align: right;
    font-family: Roboto;
    font-size: 10px;
    font-style: normal;
    font-weight: 300;
    line-height: 16px; /* 160% */
  }
`;

export const TextArea = styled.textarea`
  border: 0.5px solid #d9d9d9;
  background: #fff;
  min-height: 53.777px;
  max-width: 100%;
  /* resize: none; */

  /* muda só o texto do plachehold*/
  &::placeholder {
    color: #5e5e5e;
    font-family: Roboto;
    font-size: 10px;
    font-style: italic;
    font-weight: 300;
    line-height: 16px; /* 160% */
  }

  color: #5e5e5e;
  font-family: Roboto;
  font-size: 10px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px; /* 160% */
`;

export const MenuActions = styled.div`
  margin-top: auto;
  background: #fff;
  box-shadow: 4px 0px 4px 0px rgba(0, 0, 0, 0.25);

  width: 100%;
  height: 48.781px;

  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 16px;

  .button {
    cursor: pointer;
    padding-top: 5px;
  }

  .closed svg {
    width: 17.255px;
    height: 24.999px;
  }

  .pdf svg {
    width: 17.255px;
    height: 19.999px;
  }

  /* .lupa svg {
    flex-shrink: 0;
  } */

  .minimize svg {
    padding-top: 5px;
  }

  .btn-group {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 16px;

    svg {
      cursor: pointer;
    }
  }
`;

export const WrapIcon = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;

  img {
    width: 67.357px;
    height: 11.271px;
    margin-top: 2px;
  }

  svg {
    width: 48.436px;
    height: 12.531px;
  }
`;

export const Footer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  color: #5e5e5e;
  font-family: Roboto;
  font-size: 9px;
  font-style: normal;
  font-weight: 400;
  line-height: 10px;
  border-top: 0.5px solid #3c71dd;
  padding: 4px 0px 40px 0px;  
`;
